import { Layers } from 'lucide-react'

import { AppraisalSection } from '@/components/deals/appraisal/AppraisalSection'
import { BrrrFlipScheme } from '@/components/deals/appraisal/BrrrFlipScheme'
import { CommercialMixedUseScheme } from '@/components/deals/appraisal/CommercialMixedUseScheme'
import { ExitModeControl } from '@/components/deals/appraisal/ExitModeControl'
import { HmoScheme } from '@/components/deals/appraisal/HmoScheme'

export function SchemePanel({
  currentStrategy,
  exitMode,
  brrrState,
  hmoState,
  commercialState,
  isCoWork,
  postcodeArea,
  showValidationErrors,
  onBrrrStateChange,
  onHmoStateChange,
  onCommercialStateChange,
  onExitModeChange,
  changedEvidence = {},
  onUseLatestEvidence,
  onKeepAdoptedEvidence,
}) {
  return (
    <AppraisalSection title="Scheme" icon={Layers}>
      <div className="space-y-6">
        <div className="max-w-md">
          <ExitModeControl value={exitMode} onChange={onExitModeChange} />
        </div>
        {renderScheme({
          currentStrategy,
          exitMode,
          brrrState,
          hmoState,
          commercialState,
          isCoWork,
          postcodeArea,
          showValidationErrors,
          onBrrrStateChange,
          onHmoStateChange,
          onCommercialStateChange,
          changedEvidence,
          onUseLatestEvidence,
          onKeepAdoptedEvidence,
        })}
      </div>
    </AppraisalSection>
  )
}

function renderScheme({
  currentStrategy,
  exitMode,
  brrrState,
  hmoState,
  commercialState,
  isCoWork,
  postcodeArea,
  showValidationErrors,
  onBrrrStateChange,
  onHmoStateChange,
  onCommercialStateChange,
  changedEvidence,
  onUseLatestEvidence,
  onKeepAdoptedEvidence,
}) {
  if (currentStrategy === 'HMO') {
    return (
      <HmoScheme
        state={hmoState}
        exitMode={exitMode}
        postcodeArea={postcodeArea}
        showValidationErrors={showValidationErrors}
        onStateChange={onHmoStateChange}
        changedEvidence={changedEvidence}
        onUseLatestEvidence={onUseLatestEvidence}
        onKeepAdoptedEvidence={onKeepAdoptedEvidence}
      />
    )
  }

  if (
    currentStrategy === 'Commercial / Mixed-Use' ||
    currentStrategy === 'Commercial Conversion'
  ) {
    return (
      <CommercialMixedUseScheme
        state={commercialState}
        exitMode={exitMode}
        isCoWork={isCoWork}
        postcodeArea={postcodeArea}
        showValidationErrors={showValidationErrors}
        onStateChange={onCommercialStateChange}
        changedEvidence={changedEvidence}
        onUseLatestEvidence={onUseLatestEvidence}
        onKeepAdoptedEvidence={onKeepAdoptedEvidence}
      />
    )
  }

  return (
    <BrrrFlipScheme
      state={brrrState}
      exitMode={exitMode}
      postcodeArea={postcodeArea}
      showValidationErrors={showValidationErrors}
      onStateChange={onBrrrStateChange}
      changedEvidence={changedEvidence}
      onUseLatestEvidence={onUseLatestEvidence}
      onKeepAdoptedEvidence={onKeepAdoptedEvidence}
    />
  )
}
